/**
 * One-click QA login across tenant URLs.
 *
 * When quick-login is triggered from the wrong /o/<slug>/ (or bare apex),
 * we stash credentials, hard-navigate to the account's org login URL, then
 * auto-submit on the next page load so the router basename matches.
 */

export const QA_PENDING_LOGIN_KEY = "tnn.qa-pending-login";

export interface QaPendingLogin {
  email: string;
  password: string;
  tenantSlug: string;
}

export function storeQaPendingLogin(payload: QaPendingLogin): void {
  if (typeof window === "undefined") return;
  try {
    sessionStorage.setItem(QA_PENDING_LOGIN_KEY, JSON.stringify(payload));
  } catch {
    // Private browsing / quota - caller falls back to in-place login.
  }
}

export function consumeQaPendingLogin(): QaPendingLogin | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(QA_PENDING_LOGIN_KEY);
    sessionStorage.removeItem(QA_PENDING_LOGIN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as QaPendingLogin;
    if (!parsed?.email || !parsed?.password || !parsed?.tenantSlug) return null;
    return parsed;
  } catch {
    sessionStorage.removeItem(QA_PENDING_LOGIN_KEY);
    return null;
  }
}
